// extracted by mini-css-extract-plugin
export var externalLink = "_cs-0";
export var internalLinkLabel = "_cs-1";